import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import GarbageBGWForm from './GarbageBGForm'
import GarbageBGView from './GarbageBGView'
import { useForm, Controller } from 'react-hook-form'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { startLoading, doneLoading } from '../../../../utils/loading'
import { getSchemaSidebar } from '../../../../redux/actions/sidebar'
import { updateForm2, saveForm2 } from '../../../../redux/actions/background'
import ButtonPanel from '../../../ButtonPanel'
import WhisperMoreContent from '../../../WhisperMoreContent'
import WarningMessage from '../../../../components/message/WarningMessage/WarningMessage'

export default function GarbageBGWidget(props) {
  const { showCommandButton, schema, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(schema)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const [moreContent, setMoreContent] = useState(true)
  const [moreContentBottom, setMoreContentBottom] = useState(true)

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        console.log('call update.')
        response = await updateForm2(projectId, request)
      } else {
        console.log('call save.')
        response = await saveForm2(projectId, request)
      }

      console.log('response', response)

      if (response) {
        onChangeIsEdit(false)
        setFormSchema(response)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)
    // console.log('formSchema', formSchema)

    let all = data.allHouseholds

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      communityBasicInfo: data.communityBasicInfo,
      community: data.community,
      household: data.household,
      population: data.population,
      garbageAverage: data.garbageAverage,
      garbageType: data.garbageType,
      problemState: data.problemState,
      problemCase: data.problemCase,
      impactCommunity: data.impactCommunity,
      allHouseholds: all,
      allHouseholdsPercentage: all ? '100' : '0',
      garbageSortBefor: data.garbageSortBefor,
      garbageSortBeforPercentage:
        data.garbageSortBefor && all ? ((data.garbageSortBefor * 100) / all).toFixed(2) : '0',
      garbageBenefit: data.garbageBenefit,
      garbageBenefitPercentage:
        data.garbageBenefit && all ? ((data.garbageBenefit * 100) / all).toFixed(2) : '0',
      garbageNoSort: data.garbageNoSort,
      garbageNoSortPercentage:
        data.garbageNoSort && all ? ((data.garbageNoSort * 100) / all).toFixed(2) : '0',
      garbageSortMethod: data.garbageSortMethod || [],
      garbageBenefitMethod: data.garbageBenefitMethod || [],
      noSortGarbageManagement: data.noSortGarbageManagement,
      previousGarbageManagement: data.previousGarbageManagement,
    }
    console.log('request', request)
    handleCallService(request)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {moreContent && <div dangerouslySetInnerHTML={{ __html: formSchema.introduction }} />}

      <div style={{ textAlign: 'center', marginTop: '10px' }}>
        <WhisperMoreContent
          isShow={moreContent}
          onClick={() => {
            setMoreContent(!moreContent)
          }}
        />
      </div>

      {isEdit && showCommandButton ? (
        <GarbageBGWForm
          key="GarbageBGWForm"
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
      ) : (
        // <label> DEV... </label>
        <GarbageBGView schema={formSchema} />
      )}

      <div style={{ textAlign: 'center' }}>
        <WhisperMoreContent
          isShow={moreContent}
          onClick={() => {
            setMoreContentBottom(!moreContentBottom)
          }}
        />
      </div>

      {moreContentBottom && <div dangerouslySetInnerHTML={{ __html: formSchema.footer }} />}

      {showCommandButton && (
        <>
          <hr />
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || 'ความเป็นมาหลักการและเหตุผล'}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </>
      )}
    </Panel>
  )
}
